import { GATEKEEPER_LOCALE_TO_MARKET, LOCALE_CODES, LOCALE_TO_MARKET } from '../common/constants';

export const localeMapper = (localeCode: string) =>
    LOCALE_CODES[localeCode as keyof typeof LOCALE_CODES] ?? localeCode;

export const marketMapper = (localeCode: string) =>
    LOCALE_TO_MARKET[localeCode as keyof typeof LOCALE_TO_MARKET] ?? localeCode;

export const marketMapperFromGatekeeper = (localeCode: string) =>
    GATEKEEPER_LOCALE_TO_MARKET[localeCode as keyof typeof GATEKEEPER_LOCALE_TO_MARKET] ?? localeCode;

export const snakeToCamel = (str: string): string => {
    return str.replace(/([-_]\w)/g, (match: string) =>
        match.toUpperCase().replace('-', '').replace('_', '')
    );
};

export const isEmpty = (val: any): boolean => {
  if (val == null) return true; 
  if (val === '' || val === 'undefined') return true; 
  if (Array.isArray(val)) return val.length === 0; 
  if (typeof val === 'object') return Object.keys(val).length === 0; 
  return false;
};